import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-281" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-282" data-mp="100trpze1aoaq">
        <SectionTag icon="🎁" data-id="element-283" data-mp="zzillsx494gg">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-284" data-mp="1dza6mdm1vl3y">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-285" data-mp="1nqwimc67po7r">
          Sesiones completas y fichas prácticas para que preparar el entrenamiento deje de comerse tu
          tiempo.
        </p>
        <p className="mt-2 text-sm font-medium text-lime" data-id="element-286" data-mp="1wqb1oqk1uwi8">
          Más de 150 ejercicios y fichas · 6 Tomos · Mapa orientativo de 36 semanas · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-287" data-mp="2uz3rt58xrdud">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-white/10 bg-bg-secondary p-6 sm:p-7" data-id="element-288" data-mp="2zyq7dlc8l66c" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-289" data-mp="3iwj7kfvh7201">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-lime/10" data-id="element-290" data-mp="3iuq2h50igpu5">
                <pillar.icon size={22} className="text-lime" data-id="element-291" data-mp="3npls5yi9z143" />
              </div>
              <span className="rounded-full bg-white/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-292" data-mp="3slkme2qabdcf">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-white sm:text-xl" data-id="element-293" data-mp="5io8ribjlv8k">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-294" data-mp="22fwh0zbgijws">
              <span className="text-muted line-through" data-id="element-295" data-mp="1xkqxg75j1hbv">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-296" data-mp="2bbm7hmrri4h1">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-297" data-mp="26it3j144b060">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-298" data-mp="2l7z34q6vasef">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-white/90" data-id="element-299" data-mp="2ga71h4gf7rx1">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-300" data-mp="2u9q8tv1eqz8a" />
                  <span data-id="element-301" data-mp="2q7bp78pwzvfy">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}